import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
// Dies ist der zuvor ausnutzbare Stored-Injection-Pfad: der gespeicherte
// trackingId floss beim Admin-Update per Interpolation in die Mutation. Als
// Variable wird er nie als GraphQL geparst. Optionale Felder sind nullable.
export const updateRecyclingProcessMutation: DocumentNode = gql`
  mutation UpdateRecyclingProcess(
    $id: String!
    $correlationId: String!
    $processStart: DateTime!
    $chosenProductCategoryId: String!
    $chosenManufacturer: String!
    $countryId: String!
    $trackingId: String
    $dateOfArrival: DateTime
    $arrivedProductCategoryId: String
    $arrivedProductCategoryOther: String
    $serialNumber: String
  ) {
    updateRecyclingProcess(input: {
      id: $id
      correlationId: $correlationId
      processStart: $processStart
      chosenProductCategoryId: $chosenProductCategoryId
      chosenManufacturer: $chosenManufacturer
      countryId: $countryId
      trackingId: $trackingId
      dateOfArrival: $dateOfArrival
      arrivedProductCategoryId: $arrivedProductCategoryId
      arrivedProductCategoryOther: $arrivedProductCategoryOther
      serialNumber: $serialNumber
    })
    {
      recyclingProcess {
        id
        correlationId
        processStart
        chosenProductCategoryId
        chosenManufacturer
        countryId
        trackingId
        dateOfArrival
        arrivedProductCategoryId
        arrivedProductCategoryOther
        serialNumber
      }
    }
  }
`;
